import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-59548e0b"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "Abonnements", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, "Ihr Abonnement:", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, "Ihr Preis:", -1))
const _hoisted_5 = { class: "item-container" }

import SubscriptionItem from "./subscription-item.vue";
import { subscriptionStorageModule } from "@/store/subscription-storage";
import { Ref, ref, watch } from "vue";
import { userStorageModule } from "@/store/user-storage";
import { Subscription, User } from "@/store/model";


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const activeUserId = ref("1");
const activeUser: Ref<User | undefined> = ref(undefined);
const userSubscription: Ref<Subscription | undefined> = ref(undefined);

watch(activeUserId, () => loadUser(), { immediate: true });

function loadUser() {
  activeUser.value = userStorageModule.getUsers.find(
    (user) => user.id === activeUserId.value
  );
  userSubscription.value = subscriptionStorageModule.getSubscriptions.find(
    (subscription) => subscription.id === activeUser.value?.subscription
  );
}

function selectedSubscription(newSubscriptionId: string) {
  if (activeUser.value) {
    const newUser = JSON.parse(JSON.stringify(activeUser.value));
    newUser.subscription = newSubscriptionId;
    newUser.subscriptionPrice = undefined;
    userStorageModule.update(newUser);
    loadUser();
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("table", null, [
      _createElementVNode("tr", null, [
        _hoisted_3,
        _createElementVNode("td", null, [
          _createElementVNode("i", null, _toDisplayString(userSubscription.value
              ? userSubscription.value.duration
              : "Kein Abonnement gewählt"), 1)
        ])
      ]),
      _createElementVNode("tr", null, [
        _hoisted_4,
        _createElementVNode("td", null, _toDisplayString(activeUser.value?.subscriptionPrice ?? userSubscription.value?.price ?? 0) + " € pro Jahr ", 1)
      ])
    ]),
    _createElementVNode("div", _hoisted_5, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(subscriptionStorageModule).getSubscriptions, (subscription) => {
        return (_openBlock(), _createBlock(SubscriptionItem, {
          key: subscription.id,
          subscription: subscription,
          selected: subscription.id === userSubscription.value?.id,
          onSelected: selectedSubscription
        }, null, 8, ["subscription", "selected"]))
      }), 128))
    ])
  ]))
}
}

})